import type { App, Component } from 'vue'
import { RxkButton } from '@/components/common/RxkButton'
import { RxkTable } from '@/components/common/RxkTable'
import { registerGlobalFormComp } from './custom/form/components/registerFormComponent'
const components: {
  [propName: string]: Component
} = {
  RxkButton,
  RxkTable
}
/**
 * @author: 张胜
 * @desc：注册全局组件
 * */
export default {
  install: (Vue: App) => {
    registerGlobalFormComp(Vue)
    for (const key in components) {
      Vue.component(key, components[key])
    }
  }
}
